export var JoinPath;
(function (JoinPath) {
    JoinPath["UNKNOWN_JOIN_PATH"] = "UNKNOWN_JOIN_PATH";
    /** Member joined to the program for free */
    JoinPath["FREE"] = "FREE";
    /** Member was added to the program by site owner */
    JoinPath["ADDED"] = "ADDED";
    /** Member paid once to join the program */
    JoinPath["SINGLE_PAYMENT"] = "SINGLE_PAYMENT";
    /** Member has Paid Plan to join */
    JoinPath["PAID_PLAN"] = "PAID_PLAN";
    /** Member joined with the Free Coupon */
    JoinPath["FREE_COUPON"] = "FREE_COUPON";
})(JoinPath || (JoinPath = {}));
export var State;
(function (State) {
    /** Unknown state */
    State["UNKNOWN_STATE"] = "UNKNOWN_STATE";
    /** Member invited to participate in program */
    State["INVITED"] = "INVITED";
    /** Member asked owner to participate in program */
    State["APPROVAL_PENDING"] = "APPROVAL_PENDING";
    State["PAYMENT_PENDING"] = "PAYMENT_PENDING";
    /** Member joined the program and became participant */
    State["JOINED"] = "JOINED";
    /** Participant completed the program, and could join again */
    State["COMPLETED"] = "COMPLETED";
    /** Participant failed to complete the program, and could join again */
    State["FAILED"] = "FAILED";
    /** Participant with ended pricing plan (PP), will be joined as renew PP */
    State["SUSPENDED"] = "SUSPENDED";
})(State || (State = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
export var Status;
(function (Status) {
    /** step completed */
    Status["COMPLETED"] = "COMPLETED";
    /** participant failed to resolve step */
    Status["FAILED"] = "FAILED";
})(Status || (Status = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var CommonSortOrder;
(function (CommonSortOrder) {
    CommonSortOrder["ASC"] = "ASC";
    CommonSortOrder["DESC"] = "DESC";
})(CommonSortOrder || (CommonSortOrder = {}));
export var V3State;
(function (V3State) {
    /** not published program, visible only on BM */
    V3State["DRAFT"] = "DRAFT";
    /** program visible regarding to restrictions */
    V3State["PUBLISHED"] = "PUBLISHED";
    /** program isn't available to join. */
    V3State["ENDED"] = "ENDED";
    /** closed program. Joins and sections/steps are not available for participants. */
    V3State["ARCHIVED"] = "ARCHIVED";
})(V3State || (V3State = {}));
export var FinishCondition;
(function (FinishCondition) {
    FinishCondition["UNKNOWN_FINISH_CONDITION"] = "UNKNOWN_FINISH_CONDITION";
    /** finish participation after some time. */
    FinishCondition["TIME_EVALUATION"] = "TIME_EVALUATION";
    /** finish participation when all steps are resolved. */
    FinishCondition["ALL_STEPS_COMPLETED"] = "ALL_STEPS_COMPLETED";
})(FinishCondition || (FinishCondition = {}));
export var Trigger;
(function (Trigger) {
    /** member joins the program */
    Trigger["JOINED_TO_PROGRAM"] = "JOINED_TO_PROGRAM";
    /** at least one step completed */
    Trigger["STEP_COMPLETED"] = "STEP_COMPLETED";
    /** all steps are completed. */
    Trigger["ALL_STEPS_COMPLETED"] = "ALL_STEPS_COMPLETED";
})(Trigger || (Trigger = {}));
export var AccessType;
(function (AccessType) {
    /** join without approvals */
    AccessType["PUBLIC"] = "PUBLIC";
    /** send a join request to the owner and get an approval from him. */
    AccessType["PRIVATE"] = "PRIVATE";
    /** join possible only after owner invite. */
    AccessType["SECRET"] = "SECRET";
})(AccessType || (AccessType = {}));
export var BenefitType;
(function (BenefitType) {
    /** Should never be used */
    BenefitType["UNDEFINED"] = "UNDEFINED";
    /** Limited benefit type */
    BenefitType["LIMITED"] = "LIMITED";
    /** Unlimited benefit type */
    BenefitType["UNLIMITED"] = "UNLIMITED";
})(BenefitType || (BenefitType = {}));
export var Event;
(function (Event) {
    Event["Updated"] = "Updated";
    Event["Deleted"] = "Deleted";
    Event["Created"] = "Created";
})(Event || (Event = {}));
//# sourceMappingURL=types.impl.js.map